import { Component } from '@angular/core';
import { Input } from '@angular/core';
import { OnInit } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { NgFor } from '@angular/common';
import { ChartHeaderComponent } from '../chart-header/chart-header.component';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { ChartsCommonFunctions } from '../chartsCommonFunctions';
import { NgIf } from '@angular/common';
import { json } from 'stream/consumers';



@Component({
  standalone:true,
  selector: 'app-metric-table',
  templateUrl: './metric-table.component.html',
  styleUrls: ['./metric-table.component.scss'],
  imports: [
    NgOptimizedImage,
    NgFor,
    ChartHeaderComponent,
    NgIf
  ]
})
export class MetricTableComponent {
  constructor(private http:HttpClient,
              private route:ActivatedRoute,
              private common:ChartsCommonFunctions
            ) {}
  @Input() rcl:any = ''
  @Input() model:any = ''
  @Input() chartId:any = ''
  @Input() retailer:any = ''

  showData:boolean = false

  text_elements = {
    header:"HEADER",
    subheader:"subheader",
    caption:"caption",
    source:"source"
  }

  jsonData:any = null

  ngOnInit() {

    this.getData()
    this.dynamicText()
  }

  dynamicText() {
    document.addEventListener("DOMContentLoaded", () => {
      const table = document.querySelector("table");
      const rows = table!.querySelectorAll("tr").length;

      const headers = document.querySelectorAll("h1");
      if (rows > 5) { // Adjust this threshold as needed
        headers.forEach(header => {
          header.style.fontSize = "10px"; // Smaller size for many rows
        });
        document.querySelectorAll("p").forEach(paragraph => {
         paragraph.style.fontSize = "14px"; // Adjust as needed
});

      }
    });
  }

  getData(){

      let url = `${environment.backend_base}main/visualizations/get_visualization_data/`;
      let payload = {
        visualization: this.model,
        rcl: this.rcl,
        component: this.route.component!.name
      };



      this.http
        .post(url, payload)
        .subscribe((response: any) => {
        // console.log(response)
        this.text_elements = this.common.getTextElements(response.text_elements.retailer, 'profile')

        //TODO:finish
        this.jsonData = response.data[0].fields.json
        this.text_elements.subheader = this.text_elements.subheader.replace("[retailer print name]",this.jsonData.retailer_name)
        this.showData = true
        })

  }

}
